/**
 * Golfformatering. Delas av leaderboard och draftvy så samma score aldrig
 * visas på två sätt i olika hörn av gränssnittet.
 */

/** Score mot par: 0 blir "E", positiva får plus. Saknat värde blir tankstreck. */
export function formatToPar(n: number | null | undefined): string {
  if (n === null || n === undefined) return '–'
  if (n === 0) return 'E'
  return n > 0 ? `+${n}` : String(n)
}

/**
 * Antal spelade hål. 18 blir "F" (finished), 0 betyder att ronden inte
 * börjat — inte att spelaren står på första tee.
 */
export function formatThru(thru: number | null | undefined): string {
  if (thru === null || thru === undefined) return ''
  if (thru >= 18) return 'F'
  if (thru === 0) return '–'
  return String(thru)
}

/**
 * Har spelaren slagit ut i den pågående ronden?
 *
 * `thru` 0 och `thru` null betyder samma sak här: inga spelade hål i den här
 * ronden. Skillnaden är bara om DataGolf hunnit lägga in raden, och den
 * skillnaden angår inte den som tittar på ställningen.
 *
 * CUT, WD och NTO är inte "inte startade" — de är ute ur tävlingen, och att
 * visa en tee-tid för dem vore direkt vilseledande.
 */
export function hasTeedOff(thru: number | null | undefined, status: string | null | undefined): boolean {
  if (status === 'cut' || status === 'wd' || status === 'nto') return true
  return (thru ?? 0) > 0
}

/** "1" eller "10" — vilken tee spelaren startar på. Tom när det inte är känt. */
export function formatStartHole(hole: number | null | undefined): string {
  return hole === 10 ? ' (10)' : ''
}
